import {
  ApplicationConfig, inject, provideAppInitializer,
  provideBrowserGlobalErrorListeners, provideZoneChangeDetection,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { TitleStrategy, provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';
import { requestContextInterceptor } from './core/http/request-context.interceptor';
import { ValidationMessages } from './core/http/validation-messages';
import { provideAppTranslation } from './core/i18n/transloco.providers';
import { LocaleService } from './core/i18n/locale.service';
import { TranslatedTitleStrategy } from './core/i18n/title-strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([requestContextInterceptor, authInterceptor])),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideAppTranslation(),
    // Instantiate at bootstrap so `lang`/`dir` are correct on every page,
    // including /login — outside the shell, nothing else injects the service.
    provideAppInitializer(() => {
      inject(LocaleService);
      // Same reason, different symptom. `ValidationMessages` installs the
      // translator that `normalizeApiError` uses to write a refused request's
      // message, and every screen that shows that message would otherwise be
      // shown the server's English until something happened to inject this.
      inject(ValidationMessages);
    }),
    { provide: TitleStrategy, useClass: TranslatedTitleStrategy },
  ],
};
